module.exports = __webpack_public_path__ + "img/delete-white.c77107cf.svg";